import React, {useState} from "react";
import "./MuseumEvents.css";
import moment from 'moment';

const MuseumEvents = function (props) {
    const startDate = moment(props.data.MuseumEventStartDate).format("D.MM.YY");
    return (       
        <React.Fragment>   
            <div className="specificMuseumEvent">
                <div className="specificMuseumEventImgDiv">
                    <a href={props.data.MuseumEventImg_Url} target="_blank">
                        <img className="specificMuseumEventImg" src={props.data.MuseumEventImg_Url} data-holder-rendered="true"  alt={"תמונת " + props.data.Title}/>
                    </a>
                </div>
                <div className="specificMuseumEventInfoDiv">
                    <h2 className="specificMuseumEventTitle">{props.data.Title}</h2>
                    <p className="specificMuseumEventSummary" dangerouslySetInnerHTML={{__html: props.data.MuseumEventInfo}}></p>  
                    <div className="specificMuseumEventTimeAndLocation"><i className="far fa-calendar-alt"></i><span>{startDate}</span></div>         
                    <div className="specificMuseumEventTimeAndLocation"><i className="fas fa-clock"></i>{props.data.MuseumEventEndHour === null ? <span>בשעה {props.data.MuseumEventStartHour}</span> : <span>בין השעות {props.data.MuseumEventStartHour} - {props.data.MuseumEventEndHour}</span>}</div>
                    <div className="specificMuseumEventTimeAndLocation"><i className="fas fa-map-marker-alt"></i><span>{props.data.MuseumEventLocation}</span></div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MuseumEvents;
